import React, { useState } from 'react';
import {
  Popover,
  Box,
  FormControl,
  Select,
  MenuItem,
  Button,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Filters (sorts) out stock preferences based on the selected field and order.
 *  - createdDate: Last Added to Preferences
 *  - lastUpdatedDate: Last Report Generated (lastUpdatedDate)
 * @param {*} param0
 * @returns
 */
const FilterDialog = ({ anchorEl, open, onClose, onApply }) => {
  const [field, setField] = useState('createdDate');
  const [order, setOrder] = useState('desc');

  const handleApply = () => {
    onApply({ field, order });
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box p={2} width={250}>
        <FormControl fullWidth sx={{ paddingY: 1 }} margin="none">
          <Typography variant="caption" sx={{ mb: 0.5 }}>
            Filter By
          </Typography>
          <Select
            size="small"
            value={field}
            onChange={(e) => setField(e.target.value)}
          >
            <MenuItem value="createdDate">Last Added to Preferences</MenuItem>
            <MenuItem value="lastUpdatedDate">Last Report Generated</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ paddingY: 1 }} margin="none">
          <Typography variant="caption" sx={{ mb: 0.5 }}>
            Order
          </Typography>{' '}
          <Select
            size="small"
            value={order}
            onChange={(e) => setOrder(e.target.value)}
          >
            <MenuItem value="desc">First to Last</MenuItem>
            <MenuItem value="asc">Last to First</MenuItem>
          </Select>
        </FormControl>
        <Box display="flex" justifyContent="flex-end" mt={1}>
          <Button size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleApply}
            sx={{ ml: 1 }}
          >
            Apply
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

FilterDialog.propTypes = {
  anchorEl: PropTypes.object,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};

export default FilterDialog;
